// @flow
import {ROUTE} from 'app/constants/route';
import {selectUserData} from 'modules/auth/selectors/auth';
import {USER_ROLE_DATA} from 'modules/user/constants';
import * as React from 'react';
import {useSelector} from 'react-redux';
import {Route, Redirect} from 'react-router-dom';

type TPrivateRoute = {
    component?: React$ComponentType<any>,
    exact?: boolean,
    isOnlyAdmin?: boolean,
    path?: string | Array<string>,
};

/**
 * Приватный роут для закрытых страниц, проверят на роли
 *
 * @param isOnlyAdmin флаг что роут только для админов
 * @param component компонент который нужно отрендерить и перед этим проверить права доступа
 * @param exact совпадение путей
 * @param path путь
 * @returns {*} Компонент или редирект
 */
// eslint-disable-next-line complexity,require-jsdoc
export const PrivateRoute = ({isOnlyAdmin, component, exact, path}: TPrivateRoute) => {
    const currentUser = useSelector(selectUserData);

    const goToMain = '/' === path;
    const goToAuth = path && 0 <= path.indexOf(ROUTE.AUTH);
    const authorized = 0 !== Object.values(currentUser).length;
    const youAreAdmin = currentUser.role === USER_ROLE_DATA.ADMIN;

    if (!authorized && !goToMain && !goToAuth) {
        return <Redirect to={`/${ROUTE.AUTH}/sign-in`} />;
    }
    if (!youAreAdmin && isOnlyAdmin) {
        return <Redirect to={`/${ROUTE.TRAINING_MODULE}`} />;
    }
    if (authorized && (goToMain || goToAuth)) {
        if (youAreAdmin) {
            return <Redirect to={`/${ROUTE.DASHBOARD}`} />;
        }
        return <Redirect to={`/${ROUTE.TRAINING_MODULE}`} />;
    }

    return <Route component={component} exact={exact} path={path} />;
};
